class Person < ApplicationRecord
  self.inheritance_column = nil

  belongs_to :studio, optional: true
  belongs_to :level, optional: true
  belongs_to :age, optional: true
  belongs_to :exclude, class_name: "Person", optional: true
  belongs_to :invoice_to, class_name: "Person", optional: true
  belongs_to :package, class_name: "Billable", optional: true
  belongs_to :table, optional: true

  has_many :lead_entries, class_name: "Entry", foreign_key: :lead_id
  has_many :follow_entries, class_name: "Entry", foreign_key: :follow_id
  has_many :options, class_name: "PersonOption", foreign_key: :person_id
  has_one :judge

  scope :by_name, -> { order(:name) }

  def display_name
    name && name.split(/,\s*/).rotate.join(" ")
  end

  def present?
    judge ? judge.present : true
  end
end
